


















import { UserStateModule, FeedStateModule } from '@/store';
import { CommentModel } from '@/type/api/comment';
import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ServiceHelper } from '../../../util';

@Component<FeedContentComments>({})
export default class FeedContentComments extends Vue {
  // PROPS
  @Prop({ type: Number, required: true })
  topicsID!: number;
  @Prop({ type: Array, required: true })
  comments!: CommentModel.Read.Response.List[];
  @Prop({
    type: Function,
    required: false,
    default: () => {
      /** NP */
    },
  })
  onChangeFeed!: () => void;

  // FIELDS
  UserStateModule = UserStateModule;

  // MUTATIONS
  get selfUser() {
    return UserStateModule.selfUser;
  }
  get getIsSameMember() {
    return (comment: CommentModel.Read.Response.List) => `${comment.member_id}` === `${this.selfUser.member_id}`;
  }
  get getCommentAuthorName() {
    return (memberID: number) => UserStateModule.getUserName(memberID);
  }

  // METHODS
  handleClickRemoveComment(commentID: number) {
    FeedStateModule.removeComment({ requestBody: { comment_id: commentID }, moduleId: this.topicsID })
      .then(() => this.onChangeFeed())
      .then(() => (this as any).$snack.success({ text: 'コメントを削除しました。', button: 'OK' }))
      .catch(() => (this as any).$snack.danger({ text: 'エラーが発生しました。', button: 'OK' }));
  }
}
